import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Ticket from '@/components/Ticket'
import Movie from '@/components/Movie'
import Take from '@/components/Take'
import Buy from '@/components/Buy'
import Test from '@/components/Test'
import Detail from '@/components/Detail'
import Seat from '@/components/Seat'
import Confirm from "@/components/Confirm"
import Success_name from "@/components/Success"
import Set from "@/components/Set"
import Page from "@/components/Page"
import Tickettake from "@/components/Tickettake"
import TicketDetail from "@/components/Ticket_detail"
import TicketBuy from "@/components/Ticket_buy"
import TicketConfirm from "@/components/Ticket_confirm"
import Pay from "@/components/Pay"
import Ticket_Success from "@/components/Ticket_Success";
import NoPage from "@/components/NoPage"
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: "/ticket",
      name: "Ticket",
      component:Ticket
    },
    {
      path: "/movie",
      name: "Movie",
      component:Movie
    },
    {
      path: "/take",
      name: "Take",
      component:Take
    },
    {
      path: "/buy",
      name: "Buy",
      component:Buy
    },
    {
      path: '/test',
      name: "Test",
      component:Test
    },
    {
      path: "/confirm",
      name: "Confirm",
      component:Confirm
    },
    {
      path:"/detail",
      name: "Detail",
      component:Detail
    },
    {
      path: "/seat",
      name: "Seat",
      component:Seat
    },
    {
      path: '/success',
      name: "Success_name",
      component:Success_name
    },
    {
      path: "/set",
      name: "Set",
      component:Set
    },
    {
      path: "/page",
      name: "Page",
      component:Page
    },
    {
      path: "/ticket_get",
      name: "Ticketget",
      component:Tickettake
    },
    {
      path: "/ticket_detail",
      name: "TicketDetail",
      component:TicketDetail
    },
    {
      path: "/ticket_buy",
      name: "TicketBuy",
      component:TicketBuy
    },
    {
      path: '/ticket_confirm',
      name: "TicketConfirm",
      component:TicketConfirm
    }, {
      path: "/pay",
      name:"Pay",
      component:Pay
    }, {
      path: "/ticket_success",
      name: "Ticket_Success",
      component:Ticket_Success
    }, {
      path: "/nopage",
      name: "NoPage",
      component:NoPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js